module.exports = __webpack_public_path__ + "img/skill_bar.6d14eb05.png";